import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

/**
 * Live clock pinned to America/New_York. Updates every second.
 * Use it anywhere the admin needs to confirm the current time used by the
 * scheduler. The TV resolver also runs in NY time, so this is the canonical
 * "now" for any schedule discussion.
 */
export default function NYClock({ className = "", showLabel = true }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    weekday: "short",
  });

  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1.5 text-xs ${className}`}
      data-testid="ny-clock"
      title="Schedules use New York time"
    >
      <Clock className="h-3.5 w-3.5 text-slate-500" strokeWidth={1.75} />
      <span className="font-mono tabular-nums text-slate-900 tracking-tight">
        {fmt.format(now)}
      </span>
      {showLabel && (
        <span className="text-[10px] uppercase tracking-widest text-slate-500">NY</span>
      )}
    </div>
  );
}
